module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slow.6bf37c23.svg";